import { userConstants } from '../constants/user.constants';

export function getRoleLabel(role) {
    switch(role) {
        case userConstants.ROLE_ADMIN: return 'Administrador'; 
        case userConstants.ROLE_MANAGER: return 'Gestor'; 
        case userConstants.ROLE_USER: return 'Usuário'; 
        case userConstants.ROLE_APPROVER: return 'Aprovador'; 
        case userConstants.ROLE_SERVICE_DESK: return 'Service Desk';
        case userConstants.ROLE_AUDIT: return 'Auditor';
        case userConstants.ROLE_USER_MANAGER: return 'Gerenciador Usuários';
        default: return '';
    }
}

export function getBlockModeLabel(mode) {
    switch(mode) {
        case userConstants.BLOCK_MODE_AUTO: return 'Automático'; 
        case userConstants.BLOCK_MODE_ENABLED: return 'Ativado'; 
        case userConstants.BLOCK_MODE_DISABLED: return 'Desativado'; 
        case userConstants.BLOCK_MODE_NOT_CONFIGURED: return 'Não Alterar';
        default: return '';
    }
}

export function getGroupSyncElements(group) {
    const elements = [];
    if (group.SyncPersonalData) {
        elements.push('Dados Pessoais');
    }

    if (group.SyncManager) {
        elements.push('Superiores');
    }

    if (group.SyncWorkSchedule) {
        elements.push('Jornada de Trabalho');
    }

    if (group.AutoCreateUsers) {
        elements.push('Criar Usuários Novos');
    }

    if (elements.length === 0) {
        return 'Nenhuma Informação';
    }

    return elements.join(', ');
}

export function getGroupRemoveActions(group) {
    const elements = [];
    if (group.DisableRemovedUsers) {
        elements.push('Desativar Bloqueio');
    }

    if (group.DeactivateRemovedUsers) {
        elements.push('Inativar Usuário');
    }

    if (elements.length === 0) {
        return 'Nenhuma Ação';
    }

    return elements.join(', ');
}

export function getJourneyModeLabel(mode) {
    switch(mode) {
        case userConstants.JOURNEY_MODE_FLEXIBLE: return 'Flexível'; 
        case userConstants.JOURNEY_MODE_RIGID: return 'Rígido';         
        case userConstants.JOURNEY_MODE_NOT_CONFIGURED: return 'Não Alterar';
        default: return '';
    }
}

export function getTrileanLabel(mode) {
    switch(mode) {
        case userConstants.TRILEAN_TRUE: return 'Sim'; 
        case userConstants.TRILEAN_FALSE: return 'Não';         
        case userConstants.TRILEAN_NOT_CONFIGURED: return 'Não Alterar';
        default: return '';
    }
}

export function getApprovalStepTypeLabel(type) {
    switch(type) {
        case userConstants.APPROVAL_STEP_IMMEDIATE_SUPERIOR: return 'Superior Imediato';
        case userConstants.APPROVAL_STEP_MEDIATE_SUPERIOR: return 'Superior Mediato';
        case userConstants.APPROVAL_STEP_GROUP_APPROVERS: return 'Aprovadores de um Grupo';
        default: return '';
    }
}

export function getApprovalStepDescription(step) {
    if (step.Type == userConstants.APPROVAL_STEP_GROUP_APPROVERS) {
        return step.ApproverGroup ? `Aprovadores do Grupo ${step.ApproverGroup.Name}` : 'Aprovadores de um Grupo';
    }

    return step.ExpectedApprover
        ? `${getApprovalStepTypeLabel(step.Type)}: ${step.ExpectedApprover.Name}`
        : getApprovalStepTypeLabel(step.Type);
}

export function getWorkStatusLabel(status) {
    switch(status) {
        case userConstants.WORK_STATUS_ACTIVE: return 'Trabalhando'; 
        case userConstants.WORK_STATUS_ABSENT: return 'Afastado';                 
        default: return '';
    }
}

export function getAuthActionLabel(action) {
    switch(action) {
        case 1: return 'Login';
        case 2: return 'Senha Incorreta';
        case 3: return 'Usuário Incorreto';
        case 4: return 'Usuário Inativo';
        case 5: return 'Erro';
        
    }
    return action;
}

export function getAuthProviderLabel(provider) {
    switch (provider) {
        case 1: return 'Local';
        case 2: return 'OpenID';
        case 3: return 'LDAP';
    }
    return provider;
}

export function getActivityIntervalTypeLabel(type) {
    switch (type) {
        case 0: return 'Sessão';
        case 1: return 'Bloqueio';
        case 2: return 'Bloqueio (Fora da Jornada)';
    }
    return type;
}